module.exports = __webpack_public_path__ + "img/diamante-black.418ce051.png";